jQuery(document).ready(function ($) {

    $('select').selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });

    $(".site_header.header-landing .site-menu-toggle-open").click(function () {
        $('.site_header.header-landing').addClass("menu_active");
        $('body').addClass("toggle_menu_active");
    });

    $(".site_header.header-landing .site-menu-toggle-close").click(function () {
        $('.site_header.header-landing').removeClass("menu_active");
        $('body').removeClass("toggle_menu_active");
    });

    jQuery(".site_header.header-landing .site_header-inner .site-nav #primary-landing-menu-list li a").click(function () {
        $('.site_header.header-landing').removeClass("menu_active");
        $('body').removeClass("toggle_menu_active");
    });

    jQuery(".page-template-landing-page .team_main_wrapper_list .team_item_inner .popup_link").click(function () {
        setTimeout(function () {
            $('.lity').addClass('team_popup_open');
            $('body').addClass('lity-active');
        });
    });


    jQuery(".page-template-landing-page .site-footer .modal_popup_menu .popup_link").click(function () {
        setTimeout(function () {
            $('.lity').addClass('modal_popup_menu_open');
            $('body').addClass('lity-active');
        });
    });

    $(".page-template-landing-page .team").each(function (index) {
        var slider = $(this).find('.team_main_wrapper_list');
        $slick_prev = '<button type="button" class="slick-prev"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Next</title><path d="M24 16L16 24M16 24L24 32M16 24H32M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        $slick_next = '<button type="button" class="slick-next"><svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Previous</title><path d="M24 32L32 24M32 24L24 16M32 24H16M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
        slider.slick({
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            variableWidth: true,
            //speed: 800,
            //cssEase: 'ease',
            autoplay: true,
            autoplaySpeed: 3000,
            prevArrow: $slick_prev,
            nextArrow: $slick_next,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: false,
                        autoplay: true,
                        autoplaySpeed: 2000,
                    }
                }
            ]
        });
    });

    var scrollPosition = jQuery(window).scrollTop();
    var header = jQuery('.site_sticky_header'); // Use your header's ID

    if (scrollPosition > 0) {
        header.addClass('scrolled_header');
    } else {
        header.removeClass('scrolled_header');
    }

    const tabs = document.querySelectorAll('.tab');
    const tabContents = document.querySelectorAll('.tab_content_item');
    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            tabs.forEach(tab => tab.classList.remove('active'));
            tabContents.forEach(content => content.classList.remove('active'));
            this.classList.add('active');
            document.getElementById(this.dataset.tabContent).classList.add('active');
        });
    });

    var lochash = window.location.hash;
    if (lochash != "" && lochash != undefined && lochash != null) {
        if (jQuery(".tabbing_section .tabs_section .tabs .tab[data-pid='" + lochash + "']").length > 0) {
            jQuery(".tabbing_section .tabs_section .tabs .tab").removeClass("active");
            jQuery(".tabbing_section .tab_content .tab_content_item").removeClass("active");
            jQuery(".tabbing_section .tabs_section .tabs .tab[data-pid='" + lochash + "']").addClass("active");
            jQuery(".tabbing_section .tab_content .tab_content_item[data-content-id='" + lochash + "']").addClass("active");
        }
    }

    jQuery(document).on("click", ".tab_content_inner_data_item .tab_content_inner_data_item_inner_toggle", function (e) {
        e.preventDefault();
        var allContent = jQuery(this).parent().parent().find('.tab_content_inner_data_item_inner_content_all');
        if (jQuery(allContent).is(":hidden")) {
            jQuery('.tab_content_inner_data_item_inner_toggle').removeClass("active");
            jQuery('.tab_content_inner_data_item_inner_content_all').slideUp(400);
            jQuery(this).addClass("active");
            jQuery(this).parent().parent().find('.tab_content_inner_data_item_inner_content_all').slideDown();
        } else {
            jQuery('.tab_content_inner_data_item_inner_toggle').removeClass("active");
            jQuery('.tab_content_inner_data_item_inner_content_all').slideUp(400);
        }
    });

    customSelect();

    jQuery(".related_consumables_sec .accordion_access").on("click", function () {
        if (jQuery(this).closest(".product_list__item__inner__data").parent().find(".accordion_content").is(":hidden")) {
            jQuery(".related_consumables_sec .product_list__item__inner .accordion_content").slideUp();
            jQuery(".related_consumables_sec .product_list__item__inner .accordion_access").removeClass("active");
            jQuery(".related_consumables_sec .product_list__item__inner .accordion_access").attr("aria-expanded", "false");
            jQuery(this).closest(".product_list__item__inner__data").parent().find(".accordion_content").slideDown();
            jQuery(this).addClass("active");
            jQuery(this).attr("aria-expanded", "true");
        } else {
            jQuery(this).closest(".product_list__item__inner__data").parent().find(".accordion_content").slideUp();
            jQuery(this).removeClass("active");
            jQuery(this).attr("aria-expanded", "false");
        }
    });


    $(".left_right_heading_content_with_slider").each(function (index) {
        let custom_slider = $(this).find('.left_right_heading_content_with_slider_inner_list_slider');
        let custom_dot_item = $(this).find('.left_right_heading_content_with_slider_dots .left_right_heading_content_with_slider_dots_item');

        $(custom_slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            variableWidth: true,
            dots: false,
            speed: 1000,
            cssEase: 'ease',
            customPaging: function (slider, i) {
                return $(custom_dot_item)[i];
            }
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            console.log(nextSlide);
            $(custom_dot_item).removeClass('active');
            $(custom_dot_item).eq(nextSlide).addClass('active');
        });

        $(custom_dot_item).eq(custom_slider.slick('slickCurrentSlide')).addClass('active');

        $(custom_dot_item).on('click', function (event) {
            var slideIndex = $(this).data('slide-index');
            $(custom_slider).slick('slickGoTo', slideIndex);
            event.preventDefault();
        });

    });


    $("#primary-menu-list > .menu-item-has-children").each(function (index) {
        if (index == 0) {
            $(this).find('.sub-menu-toggle').trigger("click");
        }
    });

    offsetLeft();


    if ($(window).width() < 768) {
        $(".three_column_card_list_with_section_heading .card_list_wrapper").slick({
            arrows: false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3200,
        });
    } else {
        if ($('.three_column_card_list_with_section_heading .card_list_wrapper').hasClass("slick-initialized")) {
            $('.three_column_card_list_with_section_heading .card_list_wrapper').slick("unslick");
            $('.three_column_card_list_with_section_heading .card_list_wrapper').removeAttr("style");
        }
    }

});

jQuery(window).on("resize", function () {

    offsetLeft();

    if (jQuery(".left_right_heading_content_with_slider_inner_list_slider").length > 0 && jQuery(".left_right_heading_content_with_slider_inner_list_slider").hasClass("slick-initialized")) {
        setTimeout(function () {
            jQuery(".left_right_heading_content_with_slider_inner_list_slider").slick("refresh");
        }, 200);
    }

    if (jQuery(window).width() < 768) {
        jQuery(".three_column_card_list_with_section_heading .card_list_wrapper").slick({
            arrows: false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3200,
        });
    } else {
        if ($('.three_column_card_list_with_section_heading .card_list_wrapper').hasClass("slick-initialized")) {
            $('.three_column_card_list_with_section_heading .card_list_wrapper').slick("unslick");
            $('.three_column_card_list_with_section_heading .card_list_wrapper').removeAttr("style");
        }
    }
});


function offsetLeft() {
    if ((jQuery('.page-template-landing-page .team_main_wrapper_list .slick-list').length > 0)) {
        var boxesoffset = jQuery('.page-template-landing-page .team_main_wrapper_list .slick-list').offset(),
            boxeswindWidth = jQuery(window).width();
        jQuery('.page-template-landing-page .team_main_wrapper_list .slick-list').css('width', (boxeswindWidth - boxesoffset.left));
    }
}

jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
    customSelect();
});

jQuery(window).scroll(function () {
    var scrollPosition = jQuery(window).scrollTop();
    var header = jQuery('.site_sticky_header'); // Use your header's ID

    if (scrollPosition > 0) {
        header.addClass('scrolled_header');
    } else {
        header.removeClass('scrolled_header');
    }
});

function customSelect() {

    $('select').selectric({
        openOnFocus: false,
        disableOnMobile: false,
        nativeOnMobile: false
    });

    jQuery('select').selectric();
    jQuery(document).ready(function () {
        jQuery(document).on("change", ".gfield select", function () {
            var val1 = jQuery(this).val();
            if (val1 != "") {
                jQuery(this).parent().parent().find(".selectric").addClass("selected");
            } else {
                jQuery(this).parent().parent().find(".selectric").removeClass("selected");
            }
        });
        jQuery(".gfield select").each(function () {
            var val1 = jQuery(this).val();
            if (val1 != "") {
                jQuery(this).parent().parent().find(".selectric").addClass("selected");
            } else {
                jQuery(this).parent().parent().find(".selectric").removeClass("selected");
            }
        })
    });
}